import React from "react";
import { Helmet } from 'react-helmet';
import "./PrivacyPolicy.css";
import { useNavigate } from "react-router-dom";

function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-container">
      <Helmet>
        <title>Refund Policy | VaahanBuddy - Vehicle Services in India</title>
        <meta name="description" content="VaahanBuddy's Refund Policy outlines the conditions under which refunds are issued for challan payments and other vehicle services." />
        <meta name="keywords" content="VaahanBuddy refund policy, challan payment refund, vehicle services refund, RTO services refund" />
        <meta property="og:title" content="Refund Policy | VaahanBuddy" />
        <meta property="og:description" content="Understand VaahanBuddy's refund policy for challan payments and vehicle services." />
        <meta property="og:url" content="https://www.vaahanbuddy.com/refund-policy" />
      </Helmet>
      <div className="privacy-policy-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <span className="back-arrow">←</span> Back
        </button>
        <h1>Refund Policy</h1>
      </div>
      <div className="privacy-policy-content">
        <section>
          <h2>1. General Policy</h2>
          <p><strong>Effective Date: June 2025</strong></p>
          <p>
            At VaahanBuddy, our primary goal is to ensure a smooth and successful transaction for clearing your vehicle dues and availing vehicle-related services. Given the digital nature of challan payments directly to government portals, refunds are handled under strict conditions outlined below.
          </p>
        </section>

        <section>
          <h2>2. Eligible Refund Conditions</h2>
          <ul>
            <li><strong>Double Deductions:</strong> If your account was charged twice for the same transaction due to a technical glitch, the duplicate amount will be refunded in full.</li>
            <li><strong>Payment Failure at Authorities:</strong> If we successfully deduct the amount but the payment fails to reflect on the official RTO/Traffic Police servers within 72 hours, you are entitled to a full refund.</li>
            <li><strong>Challan Rejection by Traffic Department:</strong> In instances where the traffic department rejects the challan payment, a full refund shall be processed within 7 working days of rejection.</li>
            <li><strong>Challan Settled at Lower Value:</strong> In case your challan is settled at a lower value than your original challan amount, the balance challan amount shall be refunded back to you within 7 working days from the date of confirmation along with the valid payment receipt.</li>
            <li><strong>Challan Amount Exceeds Order Amount:</strong> If the challan payment amount exceeds the order amount, the Legal Partner will refrain from paying your challan. In such cases, a full refund shall be automatically processed within 7 working days back to the user.</li>
          </ul>
        </section>

        <section>
          <h2>3. Non-Refundable Scenarios</h2>
          <ul>
            <li>Once a challan payment is successfully processed and a receipt is generated by the respective traffic authority, the transaction <strong>cannot be cancelled or refunded</strong> under any circumstances.</li>
            <li>VaahanBuddy service fees (convenience fees) are non-refundable once the service has been successfully executed.</li>
            <li>Payments made for the wrong vehicle number entered by the user cannot be refunded. Please verify your vehicle details carefully before payment.</li>
            <li>If you have submitted your challan to VaahanBuddy for settlement but subsequently chose to have it resolved through an external legal advisor on your own, no refund will be issued against court challans.</li>
          </ul>
        </section>

        <section>
          <h2>4. Refund Processing Time</h2>
          <p>
            Approved refunds will be processed back to the original method of payment. It typically takes between <strong>7 to 10 business days</strong> for the credit to reflect in your bank account, depending on your bank's policies.
          </p>
          <p>
            In case of further delays in refund crediting, kindly contact your bank representative. VaahanBuddy is not responsible for delays or denials in processing payments at the bank's end.
          </p>
        </section>

        <section>
          <h2>5. Automatic Refund for Delayed Settlement</h2>
          <p>
            In case of any delay or failure in the settlement of your challan beyond the stipulated timelines (10-12 working days for online challans, 60-90 working days for court challans), an automatic refund will be processed within 7 working days after the stipulated time by the legal advisor.
          </p>
        </section>

        <section>
          <h2>6. How to Request a Refund</h2>
          <p>
            To initiate a refund request for an eligible transaction, please write to us with the following details:
          </p>
          <ul>
            <li>Transaction ID / Order ID</li>
            <li>Vehicle Number</li>
            <li>Registered Phone Number</li>
            <li>Brief description of the issue</li>
          </ul>
        </section>

        <section>
          <h2>Contact Us</h2>
          <ul className="contact-list">
            <li><strong>📧 Email:</strong> hello@vaahanbuddy.com</li>
            <li><strong>📞 Phone:</strong> +91 95544 94415</li>
            <li><strong>⏰ Response Time:</strong> 24-48 Business Hours</li>
            <li>
              <strong>🏢 Address:</strong> Shop No - 42 First Floor, GDA Commercial Complex, Buddha Vihar Part-A, Taramandal Gorakhpur, U.P. - 273016
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default RefundPolicy;
